// assets
import { DashboardOutlined, LineChartOutlined } from '@ant-design/icons';

// icons
const icons = {
  DashboardOutlined,
  LineChartOutlined
};

// ==============================|| MENU ITEMS - DASHBOARD ||============================== //

const dashboard = {
  id: 'group-dashboard',
  title: 'Navigation',
  type: 'group',
  children: [
    {
      id: 'dashboard',
      title: 'Dashboard',
      type: 'item',
      url: '/dashboard',
      icon: icons.DashboardOutlined,
      breadcrumbs: false
    },
    {
      id: 'customer-analytics',
      title: 'Customer Analytics',
      type: 'item',
      url: '/analytics/events',
      icon: icons.LineChartOutlined,
      breadcrumbs: false
    },

    



  ]
};

export default dashboard;
